'use strict';

export default {
  devStoreConfig: false,
  api: {
    default: 'https://sheltered-island-17755.herokuapp.com/v0',
  },
  features: {
    Ledger: false,
    BTC: false,
    BOT: false,
    Ebay: false,
    balanceSelling: false,
  }
};



// WEBPACK FOOTER //
// ./config/config.client12.js